
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 3a1 1 0 10-2 0v1H9.5A2.5 2.5 0 007 6.5V7a3 3 0 00-3 3v3.286l-.138.04a2.5 2.5 0 00-1.73 3.047l.835 3.127a1 1 0 00-.414 1.894l.105.053a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l.211.105a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l.211.105a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l.211.105a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l.211.105a3 3 0 002.684 0l.105-.053a1 1 0 00-.414-1.894l.834-3.127a2.5 2.5 0 00-1.729-3.048l-.138-.04V10a3 3 0 00-3-3v-.5A2.5 2.5 0 0014.5 4H13V3zm5 9.714V10a1 1 0 00-1-1H7a1 1 0 00-1 1v2.714l5.176-1.479a3 3 0 011.648 0L18 12.716z"}})])
          )
        }
      }
    